import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { KpiVariableOption } from 'types/GlobalCompanyGroups'

export const selectShouldFetch = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.KpiVariableOptionStore.fetched
  ],
  (fetched) => !fetched
)

// sorted variables, loading
export const selectKpiVariableOptions = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.KpiVariableOptionStore.data,
    (state: ApplicationState) => state.KpiVariableOptionStore.fetched
  ],
  (data, fetched): [KpiVariableOption[], boolean] => {
    if (!fetched) {
      return [[], true]
    }

    return [Object.values(data), false]
  }
)
